(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cta-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-contact-chat]');
    if (!button || button.disabled) return;

    const status = button.parentElement.querySelector('.contact-chat__status');
    status.hidden = true;
    status.textContent = '';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const isReady = () => typeof window.fcWidget?.open === 'function'
        && (typeof window.fcWidget.isInitialized !== 'function' || window.fcWidget.isInitialized());
      const deadline = Date.now() + 5000;
      while (!isReady() && Date.now() < deadline) {
        await new Promise((resolve) => setTimeout(resolve, 250));
      }
      if (!isReady()) throw new Error('Chat widget unavailable');
      window.fcWidget.open();
    } catch (_) {
      status.textContent = button.dataset.contactChatError;
      status.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["infinite-scroll"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('infinite-scroll')) {
    customElements.define('infinite-scroll', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('[data-load-more-link]');
        this.status = this.querySelector('[data-infinite-status]');
        this.handleClick = this.handleClick.bind(this);
        this.link?.addEventListener('click', this.handleClick);

        if (this.dataset.mode === 'automatic' && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) this.loadNext();
          }, { rootMargin: '320px 0px' });
          const sentinel = this.querySelector('[data-infinite-sentinel]');
          if (sentinel) this.observer.observe(sentinel);
        }
      }

      disconnectedCallback() {
        this.link?.removeEventListener('click', this.handleClick);
        this.observer?.disconnect();
      }

      handleClick(event) {
        event.preventDefault();
        this.loadNext();
      }

      async loadNext() {
        if (!this.link || this.loading) return;
        const target = document.querySelector(this.dataset.containerSelector);
        if (!target) return;

        this.loading = true;
        this.link.setAttribute('aria-busy', 'true');
        this.link.querySelector('[data-load-more-label]')?.setAttribute('hidden', '');
        this.link.querySelector('[data-load-more-loading]')?.removeAttribute('hidden');

        try {
          const response = await fetch(this.link.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const sourceDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const sourceContainer = sourceDocument.querySelector(this.dataset.containerSelector);
          if (!sourceContainer) throw new Error('Missing result container');

          const selector = this.dataset.itemSelector;
          const items = selector ? sourceContainer.querySelectorAll(selector) : sourceContainer.children;
          Array.from(items).forEach((item) => target.append(item.cloneNode(true)));

          const sourceControl = sourceDocument.querySelector(`[data-infinite-id="${this.dataset.infiniteId}"] [data-load-more-link]`);
          if (sourceControl) {
            this.link.href = sourceControl.href;
            this.status.textContent = this.dataset.loadedMessage || '';
            this.link.removeAttribute('aria-busy');
            this.link.querySelector('[data-load-more-label]')?.removeAttribute('hidden');
            this.link.querySelector('[data-load-more-loading]')?.setAttribute('hidden', '');
          } else {
            this.observer?.disconnect();
            this.status.textContent = this.dataset.completeMessage || '';
            this.link.remove();
            this.link = null;
            this.querySelector('[data-infinite-sentinel]')?.remove();
          }
        } catch (error) {
          this.status.textContent = this.dataset.errorMessage || '';
          this.link.removeAttribute('aria-busy');
          this.link.querySelector('[data-load-more-label]')?.removeAttribute('hidden');
          this.link.querySelector('[data-load-more-loading]')?.setAttribute('hidden', '');
        } finally {
          this.loading = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-to-top')) {
    customElements.define('scroll-to-top', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.threshold = Number.parseInt(this.dataset.threshold, 10) || 640;
        this.update = this.update.bind(this);
        this.button?.addEventListener('click', () => {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
        window.addEventListener('scroll', this.update, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.update);
      }

      update() {
        if (this.button) this.button.hidden = window.scrollY < this.threshold;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
